import React from 'react';
import { connect } from 'react-redux';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import setSearchZipAction from '../../redux/actions/searchReferenceActions/actionSearchZip'
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
    '& .MuiOutlinedInput-notchedOutline': {
      '&:hover': {
        borderColor: "rgb(0,191,255)",
      },
      '&.Mui-focused': {
        borderColor: "rgb(47, 79, 79)",
      },
    },
    '& .Mui-focused': {
      color: 'white',
    },
    width: 300,
    fontSize: 30,
    backgroundColor: 'rgba(19, 174, 236, 0.54)',
    fontWeight: 'bold'
  });

class SearchZipForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = { zip: '', zipcodes: { data: [{ 'zip': '' }] } };
        this.handleChangeForm = this.handleChangeForm.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.props.setSearchZipFunction('');
    }

    handleChangeForm = (event, value) => {
        if (value !== null) {
            this.setState({ zip: value }, () => {
                this.props.setSearchZipFunction(this.state.zip);
            });

        } else {
            this.setState({ zip: '' }, () => {
                this.props.setSearchZipFunction(this.state.zip);
            });
        }
    }

    async handleChange(event) {
        if (event.target.value.length > 0) {
            this.setState({ zip: event.target.value }, () => {
            });
        }
        if (this.state.zip !== null && this.state.zip.length >= 1) {
            const response = await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/searchRef/zip?zip=${this.state.zip}`);
            const json = await response.json();
            this.setState({ zipcodes: json })
        }
    };

    render() {

        const { classes } = this.props;
        const { t } = this.props;

        return (
            <div>
                <Autocomplete
                    classes={classes}
                    key={this.props.city}
                    id="combo-box-zip"
                    onChange={this.handleChangeForm}
                    options={this.state.zipcodes.data}
                    isOptionEqualToValue={(option, value) => option.zip === value.zip}
                    getOptionLabel={(option) => option.zip}
                    noOptionsText={'Wrong input data'}
                    renderInput={(params) => <StyledTextField {...params} error={this.props.zipError} style={{ fontSize: 30, backgroundColor: 'rgba(19, 174, 236, 0.54)', width: 300 }} onChange={this.handleChange} label={t("create_ref.zip")} variant="outlined" />}
                />
            </div>
        )
    }

}

function mapDispatchToProps(dispatch) {
    return {
        setSearchZipFunction: searchZip => {
            dispatch(setSearchZipAction(searchZip))
        }
    }
}

export default connect(null, mapDispatchToProps)(withTranslation()(SearchZipForm));